import Indicator from '../../../images/indicator.png';
import Background from '../../../images/progress-background.png';
import './Progress.css';
import ValueSpinner from './ValueSpinner';

function Progress(props: any) {
    const { errRate = 0, variant = 'classic', subtitle, isLoading = false } = props;

    const numericErrRate = Number(errRate);
    const normalizedPercent = Number.isFinite(numericErrRate)
        ? Math.max(0, Math.min(100, Math.round(numericErrRate)))
        : 0;

    if (variant === 'mobile') {
        const size = 140;
        const strokeWidth = 14;
        const center = size / 2;
        const radius = center - strokeWidth - 6;
        const circumference = 2 * Math.PI * radius;
        // While loading, leave the track bare rather than drawing a 0% arc, which reads as real data.
        const dashOffset = isLoading ? circumference : circumference * (1 - normalizedPercent / 100);

        return (
            <div className='progress-mobile'>
                <svg
                    className='progress-mobile__svg'
                    viewBox={`0 0 ${size} ${size}`}
                    role='img'
                    aria-label={`Fail rate ${normalizedPercent}%`}
                >
                    <circle
                        className='progress-mobile__track'
                        cx={center}
                        cy={center}
                        r={radius}
                        strokeWidth={strokeWidth}
                    />
                    <circle
                        className='progress-mobile__arc'
                        cx={center}
                        cy={center}
                        r={radius}
                        strokeWidth={strokeWidth}
                        strokeDasharray={circumference}
                        strokeDashoffset={dashOffset}
                    />
                </svg>
                <div className='progress-mobile__content'>
                    <span className='progress-mobile__percent'>
                        {isLoading ? <ValueSpinner color='#ff5959' size={20} /> : `${normalizedPercent}%`}
                    </span>
                    {subtitle ? (
                        <span className='progress-mobile__subtitle'>{subtitle}</span>
                    ) : isLoading ? (
                        // The ratio hasn't arrived yet. Hold its line so the percent above
                        // doesn't sit lower while loading than it will once it lands.
                        <span className='progress-mobile__subtitle' aria-hidden='true'>
                            &nbsp;
                        </span>
                    ) : null}
                </div>
            </div>
        );
    }

    const size = 102;
    const strokeWidth = 13;
    const center = size / 2;
    const radius = center - strokeWidth;
    const arcLength = 2 * Math.PI * radius;
    const arcOffset = isLoading ? arcLength : arcLength * ((100 - normalizedPercent) / 100);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <img className='background' src={Background} alt='progress background' />

            <svg className='progress' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' style={{ zIndex: 2 }}>
                <circle
                    cx='50'
                    cy='50'
                    r={radius}
                    fill='transparent'
                    strokeWidth={strokeWidth}
                    stroke='#FF3838'
                    strokeDasharray={arcLength}
                    strokeDashoffset={arcOffset}
                />
            </svg>
            {/* Swap the contents, not the element: .percent's own line box sets the
                height the gauge's column is laid out around, and it changes with
                font-size at each breakpoint. */}
            <span className='percent'>
                {isLoading ? <ValueSpinner color='#ff3838' size={34} /> : `${normalizedPercent}%`}
            </span>
            <img className='indicator' src={Indicator} alt='progress indicator' />
        </div>
    );
}

export default Progress;

// margin: '20px 0 -400px 0',
// margin: '-20px 0 0 0'
// marginTop: '-274px', marginLeft: '-300px'
// margin: '-150px 0px 0 -250px',
